export default __webpack_public_path__ + "static/media/HarmoniaUrbanismoOriginal.b2b415b1.svg";